import React, { useState } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import CoreTextArea from "../../../app/core/components/CoreTextArea/CoreTextArea";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { createAssistenza } from "./AssistenzaActions";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { t } from "i18next";

const AssistenzaPage = () => {
  const [formData, setFormData] = useState({});
  const [formError, setFormError] = useState({});

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormError((prev) => ({ ...prev, [name]: "" }));
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleContatta = async () => {
    const errors = {};
    if (!formData.reason) errors.reason = t("FieldRequired");
    if (!formData.msg?.trim()) errors.msg = t("FieldRequired");
    if (Object.keys(errors).length > 0) {
      setFormError(errors);
      return;
    }
    try {
      const response = await dispatch(
        createAssistenza({
          Subject: formData.reason,
          Description: formData.msg,
        })
      );
      if (response.payload.Result !== 1) {
        toast.error(t("ReqErr"));
        return;
      }
      toast.success(t("AssistanceMessageSended"));
    } catch (error) {
      toast.error(t("ReqErr"));
    }
  };

  return (
    <div>
      <div className="flex flex-col items-center">
        <h2 className="text-center">{t("ContactUs")}</h2>
        <p className="text-center">{t("ContactSection")}</p>
        <FormControl size="small" sx={{ width: "700px", marginTop: "2rem" }}>
          <InputLabel id="motivoContatto-label" className="text-center">
            {t("ContactReason")}
          </InputLabel>
          <Select
            name="reason"
            sx={{ maxWidth: "700px" }}
            label="motivoContatto-label"
            id="motivoContatto"
            value={formData.reason}
            onChange={handleChange}
            required
          >
            <MenuItem value="assistenza">{t("Assistance")}</MenuItem>
            <MenuItem value="informazioni">{t("Info")}</MenuItem>
          </Select>
          <FormHelperText error>{formError.reason}</FormHelperText>
        </FormControl>
        <FormControl size="small" sx={{ width: "700px", marginTop: "3rem" }}>
          <CoreTextArea
            name="msg"
            id="messaggio"
            aria-label="Messaggio"
            minRows={4}
            placeholder={t("WriteAMessage")}
            value={formData.msg}
            onChange={handleChange}
            sx={{ width: "100%", resize: "none", marginTop: "0.5rem" }}
            required
          />
          <FormHelperText error>{formError.msg}</FormHelperText>
        </FormControl>
      </div>
      <div className="flex justify-evenly mt-12">
        <CoreButton
          sx={{ width: "150px", textAlign: "center" }}
          className={"btn-round-outline"}
          variant="outline"
          testo={t("Cancel")}
          onClick={handleCancel}
        />
        <CoreButton
          sx={{ width: "150px", textAlign: "center" }}
          className={"btn-round"}
          variant="contained"
          testo={t("Send")}
          onClick={handleContatta}
        />
      </div>
    </div>
  );
};

export default AssistenzaPage;
